// Layout constants for QuickSearch components
// These ensure visual consistency between the trigger input and overlay

// Search input dimensions (shared between trigger and overlay inputs)
export const SEARCH_INPUT_HEIGHT = 40
export const SEARCH_INPUT_MAX_WIDTH = 640
export const SEARCH_INPUT_BORDER_RADIUS = 2

// Overlay container padding (MUI spacing units)
export const OVERLAY_PADDING_X = 6
export const OVERLAY_PADDING_Y = 4

// Mobile overlay padding (smaller to maximize screen usage)
export const OVERLAY_PADDING_MOBILE = 2

// Overlay appearance (pixels)
export const OVERLAY_BORDER_RADIUS = 16

// Results section padding (MUI spacing units)
export const RESULTS_PADDING_X = 2
export const RESULTS_PADDING_BOTTOM = 2

// Loading state padding (MUI spacing units)
export const LOADING_PADDING_Y = 6

// Icon and indicator sizes (pixels)
export const SEARCH_ICON_SIZE = 20
export const LOADING_INDICATOR_SIZE = 24
